const RecommendationConfigInitialState = {
  recommendation_results_loaded: false,
  current_language: (process.env.REACT_APP_DEFAULT_LANG ?? ''),
  recommendation_api_base_url: (process.env.REACT_APP_RECOMMENDATION_API_BASE_URL ?? ''),
  widgets: [{ widget_id: (process.env.REACT_APP_RECOMMENDATION_WIDGET_ID ?? ''), widget_title: (process.env.REACT_APP_RECOMMENDATION_WIDGET_TITLE ?? '') }]
};

export default RecommendationConfigInitialState;
